export const enum LOCAL_STORAGE_KEYS {
	AUTH = 'auth-store',

	THEME_AUTO_MODE = 'theme-auto-mode',
	THEME = 'theme',
}
